import {
  inQueryOnClickMode,
  inSelectMarkupOnClickMode,
} from '@/services/map-service'
import type {
  QueryModeClickProps,
  ClickMode,
  ClickModeConfigMap,
} from '@/lib/map-click-handler/types'
import { queryHandlerConfig } from '@/lib/map-click-handler/query-handler-config'
import { handleNonMarkupClick } from '@/lib/map-click-handler/feature-handlers/shared-handlers'
import pubsub from '@/lib/pubsub'

export const CLICK_MODES: ClickModeConfigMap = {
  // This is the most common type, "querying a feature on the map"
  query: {
    isActive: inQueryOnClickMode,
    handler: ({ classifiedFeatures, event, zoom }: QueryModeClickProps) => {
      // Return correct handler function for the classified query features
      for (const { key, handler } of queryHandlerConfig) {
        const featureArr = classifiedFeatures[key]
        if (featureArr.length) {
          return handler({
            features: featureArr,
            event: event,
            zoom: zoom,
            classifiedFeatures: classifiedFeatures,
          })
        }
      }

      // Fall back to a non-markup click
      return handleNonMarkupClick(event, zoom)
    },
  },
  // Selecting multiple markups (to delete, add to folder, etc)
  selectMarkup: {
    isActive: inSelectMarkupOnClickMode,
    handler: ({ classifiedFeatures }: QueryModeClickProps) =>
      pubsub.publish(
        'selectMapContent',
        classifiedFeatures.markupsClicked.map((m) => m.properties?.id)
      ),
  },
}

/**
 * *(AI-generated)*
 * Returns the currently active click mode based on the current map interaction state.
 */
export function getClickMode(): ClickMode {
  for (const [mode, config] of Object.entries(CLICK_MODES)) {
    if (config.isActive()) {
      return mode as ClickMode
    }
  }
  return 'default'
}
